import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../containers/dockPadStyle'
import classNames from 'classnames'
import { compose } from 'redux'

import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import { connect } from 'react-redux'

import DialogContent from '@material-ui/core/DialogContent'
import TextField from '@material-ui/core/TextField'
import { homeActions } from '../../actions/home.actions'
import { entityActions } from '../../actions/entity.actions'
import { withFirebase, firebaseConnect } from 'react-redux-firebase'
import { withRouter } from 'react-router-dom'
import { dockPadEntityMapToList } from '../../containers/DockPadFormTemplates'
import { getRealInviteUsers, getProjectUsersList, getProjectUsers, getProjectId, getProjectSubscription } from '../../selectors/project.selector'
import { isInviteDialogOpen } from '../../selectors/dialog.selector'

class InviteDialog extends React.Component {
  state = {
    emailText: null
  }

  handleListItemClick(value) {
    const { dispatch } = this.props
    dispatch(homeActions.taskDialogSelect(value))
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(homeActions.closeInviteDialog())
  }

  inviteUser() {
    const { dispatch, projectId, subscription } = this.props
    let plan
    // if plan is not instantiated, set it to Concrete
    if (!subscription) {
      plan = 'Concrete'
    } else {
      plan = subscription.plan
    }

    const existingUsers =
      Object.keys(this.props.invitedUsers).length + Object.keys(this.props.projectUsers).length
    if (!!this.state.emailText && this.state.emailText.includes(',')) {
      dispatch(
        entityActions.addInviteUsers(
          projectId,
          this.state.emailText,
          plan,
          existingUsers
        )
      )
    } else if (!!this.state.emailText) {
      dispatch(
        entityActions.addInviteUserWithPlan(
          projectId,
          this.state.emailText,
          plan,
          existingUsers
        )
      )
    }
  }

  handleTextChange(event) {
    this.setState({
      emailText: event.target.value
    })
  }

  render() {
    const { classes, isInviteDialogOpen } = this.props
    return (
      <Dialog
        open={isInviteDialogOpen}
        maxWidth='md'
        onBackdropClick={this.closeDialog.bind(this)}
        aria-labelledby='simple-dialog-title'
        fullWidth >
        <DialogTitle id='simple-dialog-title'>
          Invite Users By E-mail
        </DialogTitle>
        <DialogContent style={{ width: '100%' }}>
          <TextField
            margin='dense'
            id='name'
            label='Type in E-mail Addresses, separated with comma'
            type='email'
            onChange={this.handleTextChange.bind(this)}
            variant='outlined'
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button
            className={classNames(classes.cancelButton)}
            variant='outlined'
            onClick={this.closeDialog.bind(this)}>
            Cancel
          </Button>
          <Button
            className={classNames(classes.sendButton)}
            variant='outlined'
            onClick={this.inviteUser.bind(this)}>
            Send Invite
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default compose(
  withRouter,
  withFirebase,
  connect((state, props) => {
    return {
      projectId: getProjectId(state)
    }
  }),
  firebaseConnect(props => {
    return [
      {
        path: 'user_invites',
        queryParams: ['orderByChild=project_uid', `equalTo=${props.projectId}`]
      }
    ]
  }),
  connect((state, props) => {
    return {
      invitedUsers: getRealInviteUsers(state),
      projectUsers: getProjectUsers(state),
      subscription: getProjectSubscription(state),
      isInviteDialogOpen: isInviteDialogOpen(state)
    }
  }),
  withStyles(styles, { withTheme: true })
)(InviteDialog)



// WEBPACK FOOTER //
// ./src/components/Dialogs/InviteDialog.tsx